import React from 'react'
import ACard from '../../Materials/ACard'

const About = () => {
  return (
    <ACard>
      <h1>About</h1>
      <ACard>Content 1</ACard>
      <ACard>Content 2</ACard>
      <ACard>Content 3</ACard>
      <ACard>Content 4</ACard>
      <ACard>Content 5</ACard>
      
    </ACard>
  )
}

export default About